
/* 
    API URL FOR MAKE REQUEST TO SERVER
*/
export const PROD_DOMAIN:string = process.env.REACT_APP_API_DOMAIN || 'http://localhost:8000';
export const FRONTEND_PROD_DOMAIN:string = process.env.FRONTEND_APP_URL || 'https://www.transportganj.com/app';